// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KCc1","top":"styles_top__1US6Y","left":"styles_left__3Cm3Q","description":"styles_description__Eva8k"};